import React from "react";
import { useFormik } from "formik";
import { CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import { NuInput } from "../../../../Components/Utils/Input";

const FilterModal = ({ show, onClose, filterValues, onApply, onClear }) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      min_total: filterValues.min_total || "",
      max_total: filterValues.max_total || "",
      from_date: filterValues.from_date || "",
      to_date: filterValues.to_date || "",
    },
    onSubmit: (values) => {
      onApply(values);
      onClose();
    },
  });

  if (!show) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
      <div className="animate-scale-in w-full sm:w-[480px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
        <h2 className="text-lg font-bold text-gray-800 mb-4">Filter Ageing Analysis</h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="flex flex-col gap-3 mb-4">
            <NuInput
              label="Min Total"
              type="number"
              name="min_total"
              placeholder="e.g. 1000"
              formik={formik}
              px="0"
              width="w-full"
            />
            <NuInput
              label="Max Total"
              type="number"
              name="max_total"
              placeholder="e.g. 50000"
              formik={formik}
              px="0"
              width="w-full"
            />
            <NuInput
              label="From Date"
              type="date"
              name="from_date"
              formik={formik}
              px="0"
              width="w-full"
            />
            <NuInput
              label="To Date"
              type="date"
              name="to_date"
              formik={formik}
              px="0"
              width="w-full"
            />
          </div>
          <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
            <CancelButton handleClick={onClose} />
            <SubmitButton name="Apply" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default FilterModal;
